import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const redemptionStatusQuery = gql`
  query RedemptionStatus($redemptionId: ID!) {
    helixOrderLatest(redemptionId: $redemptionId) {
      action
      data {
        ... on HelixOrderProductShipped {
          trackingNumber
          trackingProviderName
        }
      }
    }
  }
`

export const redemptionStatusQueryKey = getQueryNames(redemptionStatusQuery)[0]

export default redemptionStatusQuery
